import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Detail from "@/views/Detail.vue";
import { store } from "@/store";
import { Mutation } from "@/store/session/types";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/device/:hash",
    name: "Detail",
    component: Detail
  },
  {
    path: "/contact/:question?",
    name: "Contact",
    props: true,
    component: () =>
      import("../views/Contact.vue"),
  },
  {
    path: "/thankyou/:ids",
    name: "OrderComplete",
    props: true,
    component: () =>
      import("../views/OrderComplete.vue"),
  },
  {
    path: "/order-failed",
    name: "OrderFailed",
    props: true,
    component: () =>
      import("../views/OrderFailed.vue"),
  },
  {
    path: "/login/:token",
    name: "Login",
    beforeEnter: (to, from, next) => {
      let token = to.params.token;

      if (token === "" || token === undefined) {
        store.commit(`${Mutation.LOGOUT}`);
        window.location = process.env.VUE_APP_LOGIN_URL;
      } else {
        store.commit(`${Mutation.SET_TOKEN}`, token);
        next("/");
      }
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
